import React, { useEffect } from 'react';

// reactstrap components
import { Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

// views
import Identificacao from "../../../views/Shared/Destino/Identificacao";
import Locais from '../../../views/Shared/Destino/Locais';
import Documentos from "../../../views/Shared/Documentos";

//Context
import { useAuth } from '../../../context/auth';

export default function ManutencaoDestinoForm({ item, handleReturn }) {

    const {setLoading} = useAuth();


    const [protocolo, set_protocolo] = React.useState(item);
    const [opcao, set_opcao] = React.useState({
        tipoCadastro: "Protocolo",
        segmento: "Destino Final",
        categoria: { sigla: "RCC" }
    });

    const [step, set_step] = React.useState(0);
    const handleProximoStep = (_protocolo) => {
        if ((step == 2 && opcao.categoria.sigla != "RGG") || (step == 1 && opcao.categoria.sigla == "RGG"))
            showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                handleReturn();
            });
        else {
            set_protocolo(_protocolo);
            set_step(step + 1);
        }
    }
    const handleStepAnterior = (_protocolo) => {
        set_protocolo(_protocolo)
        set_step(step - 1);
    }

    const [permiteManutencao, set_permiteManutencao] = React.useState(false);
    const handleVerificaPermissaoManutencao = () => {
        setLoading(true);

        api_GET('Protocolo/VerifyExistsRequeriments/' + protocolo.protocolo_Id).then(result => {
            set_permiteManutencao(result.data.sucesso);
            if (!result.data.sucesso) {
                showMessage("Aviso", "Não permitida a manutenção do cadastro. " + result.data.mensagem, 'warning', null);
            }
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        set_opcao({
            tipoCadastro: "Protocolo",
            segmento: "Destino Final",
            categoria: item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
        });
        set_protocolo(item);
        if (item)
            handleVerificaPermissaoManutencao();
    }, []);

    const steps = [];

    if (protocolo != null) {
        if (protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla != "RGG")
            steps.push('Identificação', 'Locais de Destinação', 'Documentação');
        else
            steps.push('Identificação', 'Documentação');
    }

    return (
        <>
            {opcao != null &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {step == 0 && <Identificacao item={protocolo} tipoCadastro="Protocolo" permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleReturn={handleReturn}></Identificacao>}
                    {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla != "RGG" ? step == 1 && <Locais item={protocolo} tipoCadastro="Protocolo" permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Locais> : ""}
                    {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla != "RGG" ?
                        step == 2 && <Documentos item={protocolo} opcao={opcao} permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>
                        :
                        step == 1 && <Documentos item={protocolo} opcao={opcao} permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>
                    }
                </div>
            }
        </>
    );
}